import { JobTrackerExtensionBanner } from './JobTrackerExtensionBanner'
export default JobTrackerExtensionBanner
